module.exports = __webpack_public_path__ + "static/media/location10.7df38d17.webp";